import { render } from "./EmailConfirmation.vue?vue&type=template&id=e442af84&scoped=true"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js"

import "./EmailConfirmation.vue?vue&type=style&index=0&id=e442af84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e442af84"]])

export default __exports__